var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v(" About Me ")]),_c('hr'),_c('About')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }